import { useConditionalRendering } from 'src/shared/useConditionalRendering';
import { C40SimpleSignUpProps } from './C40SimpleSignUp.types';
import { SimpleSignupProps } from '@ahc-digital/component-library';
import { getDroplink } from 'src/shared/param-utils';

export function CreateSimpleSignUpModel(props?: C40SimpleSignUpProps) {
  type t = SimpleSignupProps;

  const { params, fields } = props || {};

  const { renderText, renderRichText, renderLink } = useConditionalRendering();

  return {
    backgroundColor: getDroplink<t['backgroundColor']>(params?.BackgroundColor, 'white'),
    headlineTag: getDroplink<t['headlineTag']>(params?.HeadlineTag, 'p'),
    alignment: getDroplink<t['alignment']>(params?.Alignment),
    headline: renderText(fields?.Headline),
    supportCopy: renderRichText(fields?.SupportCopy),
    cta: renderLink(fields?.CTA),
  };
}
